// A submission is immutable until the server conclusively accepts/rejects it.
// localStorage failures propagate before any network request is made.
export function newRequestId() {
  if (!globalThis.crypto?.randomUUID) throw new Error('Secure operation identity is unavailable.');
  return globalThis.crypto.randomUUID();
}
function stable(v) {
  if (v === null || typeof v !== 'object') return JSON.stringify(v);
  if (Array.isArray(v)) return `[${v.map(stable).join(',')}]`;
  return `{${Object.keys(v).sort().map(k => `${JSON.stringify(k)}:${stable(v[k])}`).join(',')}}`;
}
export function readSubmission(type, businessId, uid) {
  const raw = localStorage.getItem(`workbill_submission_v1:${businessId}:${uid}:${type}`);
  return raw ? JSON.parse(raw) : null;
}
function semantic(payload) {
  const copy = JSON.parse(JSON.stringify(payload));
  delete copy.requestId;
  delete copy.publicInvoiceDraft;
  delete copy.auditEntries;
  for (const k of ['createdAt', 'updatedAt', 'invoiceNumber', 'invoiceSequence', 'publicId', 'publicToken', 'publicInvoiceUrl', 'gstConfirmedAt']) delete copy.invoiceDraft?.[k];
  return stable(copy);
}
export function beginSubmission(type, payload, actorUid) {
  const key = `workbill_submission_v1:${payload.businessId}:${actorUid}:${type}`;
  const raw = localStorage.getItem(key);
  if (raw) {
    const saved = JSON.parse(raw);
    if (semantic(saved.payload) !== semantic(payload)) throw new Error('A previous submission is unresolved. Restore and retry it before editing or starting another bill.');
    return saved;
  }
  const saved = JSON.parse(JSON.stringify({ key, type, actorUid, payload: { ...payload, requestId: payload.requestId || newRequestId() } }));
  localStorage.setItem(key, JSON.stringify(saved));
  return saved;
}
export function finishSubmission(submission) {
  if (submission?.key) localStorage.removeItem(submission.key);
}
export function isConclusiveRejection(error) {
  return error?.details?.operationUncommitted === true;
}

export async function submissionFingerprint(value) {
  const bytes = new TextEncoder().encode(stable(value));
  const hash = await globalThis.crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(hash)].map(b => b.toString(16).padStart(2, '0')).join('');
}
